/* eslint-disable @typescript-eslint/restrict-template-expressions */
//Navigation
import Sidebar from 'components/Navigation/Sidebar';
import Topbar from 'components/Navigation/Topbar';
import FullPageLoader from 'components/FullPageLoader';
import {useGetVersionQuery} from 'services';
// eslint-disable-next-line no-restricted-imports
import packageJson from '../../../package.json';

interface IProps {
	children: React.ReactNode;
	isLoading?: boolean;
}

const LayoutMain: React.FC<IProps> = ({children, isLoading = false}) => {
	const {data: getVersion} = useGetVersionQuery();

	const handleTop = () =>
		window.scrollTo({top: 0, left: 0, behavior: 'smooth'});

	const date = new Date();
	const year = date.getFullYear();

	return (
		<>
			{isLoading && <FullPageLoader />}

			<div id="wrapper" data-testid="wrapper">
				<Sidebar />

				<div id="content-wrapper" className="d-flex flex-column">
					<div id="content">
						<Topbar />

						<div className="col-md-12">{children}</div>
					</div>

					<footer className="mt-4 pt-2 py-3 border-top">
						<div className="container  text-center">
							<span className="text-muted">
								{`GUI PCRF Version ${packageJson.version} | Core PCRF Version ${getVersion} | © Copyright Summa
								Networks ${year} | All rights reserved.`}
							</span>
						</div>
					</footer>
				</div>

				<a
					className="scroll-to-top rounded"
					id="to-top"
					href="#page-top"
					onClick={handleTop}>
					<i className="bi bi-chevron-up" />
				</a>
			</div>
		</>
	);
};
export default LayoutMain;
